import React from "react";
import { Button, Toast } from "antd-mobile";
import { post } from "../../../utils/request";
import { href } from "../../../utils/util";
import api from "./api";
import Cookies from "js-cookie";
import { loadingToast } from "../loading";

import "./index.less";

import docx from "./SQSMB.docx";

var timer;
class AttestationType extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            caType: "MOBILE", //认证方式
            second: 59,
            secondType: false,
            SQZS: "", // 授权书
            SQZSUrl: "",
            personalIdentity3Key: "",
        };
    }

    componentWillReceiveProps(prevProps) {
        if (prevProps.fangShi !== this.state.caType) {
            this.setState(
                {
                    caType: prevProps.fangShi,
                },
                () => {
                    console.log(this.state.caType);
                }
            );
        }
        if (
            this.state.SQZSUrl !== prevProps.SQZSUrl &&
            prevProps.SQZSUrl &&
            !this.state.SQZSUrl
        ) {
            this.setState({
                SQZS: [],
                SQZSUrl: prevProps.SQZSUrl,
            });
        }
    }

    viewPort = () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf("micromessenger") > -1,
            isQQ: u.indexOf("qq/") > -1,
            trident: u.indexOf("trident") > -1, //IE内核
            presto: u.indexOf("presto") > -1, //opera内核
            webKit: u.indexOf("applewebkit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("gecko") > -1 && u.indexOf("khtml") == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) || !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf("android") > -1 || u.indexOf("linux") > -1, //android终端或者uc浏览器
            iPhone: u.indexOf("iphone") > -1 || u.indexOf("mac") > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("ipad") > -1, //是否iPad
            webApp: u.indexOf("safari") == -1, //是否web应该程序，没有头部与底部
        };
    };

    appShare(ops, shareType) {
        let viewPort = this.viewPort();
        if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
            if (window.webkit) {
                window.webkit.messageHandlers.downloadFile.postMessage(ops);
            }
        } else {
            if (window.huilian) {
                window.huilian.downloadFile(JSON.stringify(ops));
            }
        }
    }

    // 获取验证码
    timerFN = () => {
        const { urlOps } = this.props;
        var shouji = document.getElementById("phoneNumber").value;
        if (!shouji || shouji.length < 11) {
            Toast.info("请填写正确的手机号码", 1);
            return;
        }
        clearInterval(timer);
        let _this = this;
        post({
            url:
                api.h5.sendCertificateCode + "?app_stoken=" + urlOps.app_stoken,
            data: {
                account:
                    this.props.source === "GR"
                        ? shouji
                        : shouji + "" + this.props.regCode, //用户账号	唯一标识（个人-手机号；企业-手机号+统一社会信用代码/工商注册号）
                name: this.props.customerName, //姓名
                identity: this.props.cerificationNo, //身份证号
                phoneNumber: shouji, //手机号
                userType: this.props.source === "GR" ? 1 : 2,
                plateformType: this.props.plateformType,
            },
        }).then(
            (res) => {
                console.log("验证码", res);
                if (res.result === "success") {
                    _this.setState(
                        {
                            second: 59,
                            personalIdentity3Key: res.data,
                            secondType: true,
                        },
                        () => {
                            let { second } = _this.state;
                            timer = setInterval(function () {
                                if (second < 0) {
                                    clearInterval(timer);
                                    _this.setState({
                                        secondType: false,
                                    });
                                } else {
                                    _this.setState({
                                        second: second--,
                                    });
                                }
                            }, 1000);
                        }
                    );
                } else {
                    if (res.code == "-1") {
                        Toast.info("登录失效", 1);
                    } else {
                        Toast.info(res.msg, 1);
                    }
                }
            },
            (res) => {
                if (res.code == "-1") {
                    Toast.info("登录失效", 1);
                } else {
                    Toast.info(res.msg, 1);
                }
            }
        );
    };

    imgUpload = (file, FN) => {
        const { urlOps } = this.props;
        loadingToast("图片上传中...");
        post({
            url: api.attachment + "?app_stoken=" + urlOps.app_stoken,
            headers: {
                "Content-Type": "multipart/form-data;",
            },
            data: {
                attachmenType: "IMGS_ALL",
                file: [file],
            },
        }).then(
            (res) => {
                if (res.result === "success" && res.data) {
                    console.log(res.data);
                    FN(res.data[0].attachmenturl);
                } else {
                    if (res.code == "-1") {
                        Toast.info("登录失效", 1);
                    } else {
                        Toast.info(res.msg, 1);
                    }
                }
            },
            (res) => {
                if (res.code == "-1") {
                    Toast.info("登录失效", 1);
                } else {
                    Toast.info(res.msg, 1);
                }
            }
        );
    };

    // 授权书
    imgChange = () => {
        let _this = this;
        var reader = new FileReader();
        var SQZS = document.getElementById("SQZS").files;
        if (SQZS[0].size > 3145728) {
            Toast.info("授权书不能大于3M", 1);
            return;
        }
        reader.readAsDataURL(SQZS[0]);
        reader.onload = function () {
            // console.log(this.result)
            _this.imgUpload(SQZS[0], (img) => {
                _this.setState(
                    {
                        SQZSUrl: img,
                        SQZS: this.result.split("base64,")[1],
                    },
                    () => {
                        Toast.hide();
                        _this.onCancel();
                    }
                );
            });
        };
    };

    onCancel = () => {
        let { caType, SQZS, SQZSUrl, personalIdentity3Key } = this.state;
        let { plateformType } = this.props;
        if (caType !== "AUTH") {
            if (caType === "PERSONAL") {
                this.props.onCancel("", "", caType, personalIdentity3Key);
            } else {
                this.props.onCancel(
                    document.getElementById("phoneNumber").value,
                    plateformType === "SSQ"
                        ? document.getElementById("YZM").value
                        : "",
                    caType,
                    personalIdentity3Key
                );
            }
        } else {
            this.props.onCancel(
                document.getElementById("phoneNumber").value,
                plateformType === "SSQ"
                    ? document.getElementById("YZM").value
                    : "",
                caType,
                personalIdentity3Key,
                SQZSUrl
            );
        }
    };

    render() {
        let { secondType, second, personalIdentity3Key } = this.state;
        let { selectSign, plateformType } = this.props;
        return (
            <div className="AttestationTypeBox">
                {this.state.caType !== "AUTH" ? (
                    <div>
                        {plateformType === "SSQ" ? (
                            <div className="selectBox">
                                <div
                                    className={[
                                        "SJH ",
                                        this.state.caType === "MOBILE"
                                            ? "active"
                                            : "",
                                    ].join(" ")}
                                    onClick={() => {
                                        this.setState(
                                            {
                                                caType: "MOBILE",
                                            },
                                            () => {
                                                this.onCancel();
                                            }
                                        );
                                    }}
                                >
                                    <i></i>
                                    <div>
                                        <div>
                                            {selectSign ? (
                                                <span>{selectSign}</span>
                                            ) : (
                                                ""
                                            )}
                                            手机号认证
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={[
                                        "SL ",
                                        this.state.caType === "PERSONAL"
                                            ? "active"
                                            : "",
                                    ].join(" ")}
                                    onClick={() => {
                                        // Toast.info('暂不支持刷脸认证', 2);
                                        if (!this.props.urlOps.mobileNumber) {
                                            Toast.info("暂不支持刷脸认证", 2);
                                            return;
                                        }
                                        this.setState(
                                            {
                                                caType: "PERSONAL",
                                            },
                                            () => {
                                                this.onCancel();
                                            }
                                        );
                                    }}
                                >
                                    <i></i>
                                    <div>
                                        <div>
                                            {selectSign ? (
                                                <span>{selectSign}</span>
                                            ) : (
                                                ""
                                            )}
                                            刷脸认证
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                        {this.state.caType === "MOBILE" ? (
                            <div className="numberBox">
                                <div className="toastText">
                                    *请确保该手机号是在运营商处实名购买，不支持虚拟电话卡，否则无法通过实名认证。
                                </div>
                                <div>
                                    <label htmlFor="phoneNumber">
                                        <span>
                                            {selectSign ? selectSign : ""}手机号
                                        </span>
                                        <input
                                            id="phoneNumber"
                                            type="tel"
                                            maxLength="11"
                                            placeholder="请填写"
                                            onChange={(e) => {
                                                this.onCancel();
                                            }}
                                            onBlur={() => {
                                                this.onCancel();
                                            }}
                                        />
                                        {plateformType === "SSQ" ? (
                                            secondType ? (
                                                <div className="second secondText">
                                                    {second}S
                                                </div>
                                            ) : (
                                                <div
                                                    className="second"
                                                    onClick={this.timerFN}
                                                >
                                                    获取验证码
                                                </div>
                                            )
                                        ) : (
                                            ""
                                        )}
                                    </label>
                                    {plateformType === "SSQ" ? (
                                        <label htmlFor="YZM">
                                            <span>验证码</span>
                                            <input
                                                id="YZM"
                                                type="number"
                                                placeholder="请填写"
                                                onChange={(e) => {
                                                    this.onCancel();
                                                }}
                                                onBlur={() => {
                                                    this.onCancel();
                                                }}
                                            />
                                        </label>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                ) : (
                    <div>
                        <div className="numberBox">
                            <div
                                className="toastText"
                                style={{ color: "#f00" }}
                            >
                                *选择授权书认证，将以电子形式发送给法人进行认证。
                            </div>
                            <div className="toastText">
                                *请确保该手机号是在运营商处实名购买，不支持虚拟电话卡，否则无法通过实名认证。
                            </div>
                            <div>
                                <label htmlFor="phoneNumber">
                                    <span>经办人手机号</span>
                                    <input
                                        id="phoneNumber"
                                        type="tel"
                                        maxLength="11"
                                        placeholder="请填写"
                                        onChange={(e) => {
                                            this.onCancel();
                                        }}
                                        onBlur={() => {
                                            this.onCancel();
                                        }}
                                    />
                                    {plateformType === "SSQ" ? (
                                        secondType ? (
                                            <div className="second secondText">
                                                {second}S
                                            </div>
                                        ) : (
                                            <div
                                                className="second"
                                                onClick={this.timerFN}
                                            >
                                                获取验证码
                                            </div>
                                        )
                                    ) : (
                                        ""
                                    )}
                                </label>
                                {plateformType === "SSQ" ? (
                                    <label htmlFor="YZM">
                                        <span>验证码</span>
                                        <input
                                            id="YZM"
                                            type="number"
                                            placeholder="请填写"
                                            onChange={(e) => {
                                                this.onCancel();
                                            }}
                                            onBlur={() => {
                                                this.onCancel();
                                            }}
                                        />
                                    </label>
                                ) : (
                                    ""
                                )}
                                {plateformType === "SSQ" ? (
                                    <div>
                                        <span>授权书上传</span>
                                        <div>
                                            <label
                                                htmlFor="SQZS"
                                                style={{
                                                    backgroundImage: this.state
                                                        .SQZS
                                                        ? "url(" +
                                                          this.state.SQZSUrl +
                                                          ")"
                                                        : "",
                                                    backgroundSize: "contain",
                                                }}
                                            >
                                                <input
                                                    id="SQZS"
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={() => {
                                                        this.imgChange();
                                                    }}
                                                />
                                            </label>
                                            <div>
                                                <a
                                                    onClick={() => {
                                                        this.appShare({
                                                            dataImg:
                                                                "https://static.hellogil.com/oss-prod-unsafe-group/statics/bce6ebe9d18142829540aa296e9d588d.docx",
                                                            imgName: "授权书",
                                                        });
                                                    }}
                                                >
                                                    授权书下载
                                                </a>
                                                <p>
                                                    下载授权书到本地后打印，加盖公章后牌照上传，支持上传图片格式：jpeg、jpg、png格式且大小不超过3M。
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    ""
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default AttestationType;



// WEBPACK FOOTER //
// ./src/identityVerification/modules/attestationType/index.js